export default __webpack_public_path__ + "static/media/error.add3fb08.svg";